import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Paper, Typography, Button, Divider, Stack } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import LogoutIcon from "@mui/icons-material/Logout";

export default function SubscriptionExpired() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();


  const handlePayNow = async () => {
    try {
      setLoading(true);

      const clientId = localStorage.getItem("trialClientId");

      if (!clientId) {
        alert("Client information not found. Please login again.");
        return;
      }

      const response = await axios.post(
        // "http://localhost:5000/api/admin/subscription-invoices/create-activation",
        "/api/admin/subscription-invoices/create-activation",
        {
          client_id: Number(clientId),
        },
      );

//       alert(
//         `Activation Invoice Created

// Invoice No : ${response.data.invoice_no}`,
//       );
navigate(
  `/activation-payment/${response.data.invoice_id}`
);

    } catch (error) {
      console.error(error);

      alert(
        error?.response?.data?.message || "Failed to create activation invoice",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#F4F7FE",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: 3,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: 650,
          borderRadius: 2,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            background: "linear-gradient(135deg, #B91C1C 0%, #DC2626 100%)",
            color: "white",
            p: 3,
          }}
        >
          <Typography variant="h4" fontWeight="bold">
            WheelsERP Subscription
          </Typography>
        </Box>

        <Box p={4}>
          <Box display="flex" alignItems="center" gap={1} mb={2}>
            <WarningAmberIcon color="warning" />
            <Typography variant="h5" fontWeight="bold">
              Trial Expired
            </Typography>
          </Box>

          <Typography mb={3}>Your 15-day trial period has expired.</Typography>

          <Divider sx={{ mb: 3 }} />

          <Stack spacing={2}>
            <Box display="flex" justifyContent="space-between">
              <Typography>Company</Typography>
              <Typography fontWeight="bold">ECO TRAVELS</Typography>
            </Box>

            <Box display="flex" justifyContent="space-between">
              <Typography>Account Status</Typography>
              <Typography color="error" fontWeight="bold">
                TRIAL EXPIRED
              </Typography>
            </Box>

            <Box display="flex" justifyContent="space-between">
              <Typography>Activation Fee</Typography>
              <Typography color="primary" fontWeight="bold" fontSize={24}>
                ₹15,000
              </Typography>
            </Box>
          </Stack>

          <Divider sx={{ my: 3 }} />

          {/* <Button
            variant="contained"
            size="large"
            fullWidth
            onClick={handlePayNow}
            disabled={loading}
          >
            {loading ? "Creating Invoice..." : "PAY NOW"}
          </Button> */}
<Button
  variant="contained"
  size="large"
  fullWidth
  onClick={handlePayNow}
  disabled={loading}
  sx={{
    mt: 1,
    mb: 2,
    height: 55,
    fontSize: "18px",
    fontWeight: "bold",
    backgroundColor: "#DC2626",
    "&:hover": {
      backgroundColor: "#B91C1C",
    },
    "&.Mui-disabled": {
      backgroundColor: "#FCA5A5",
      color: "white",
    },
  }}
>
  {loading ? "Creating Invoice..." : "PAY NOW"}
</Button>
          <Button
            variant="outlined"
            startIcon={<LogoutIcon />}
            fullWidth
            onClick={() => {
              localStorage.clear();
              window.location.href = "/login";
            }}
          >
            Logout
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
